import { Dimensions } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  useDeviceSize,
} from "rn-responsive-styles";

const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: "100vh",
      flexDirection: "row",
      justifyContent: "center",
      paddingTop: 40,
      backgroundColor: "#f2f4f5",
      backgroundImage:
        "linear-gradient(to top, #f2f4f5, #f2f4f5 50%, #eee 50%, #333 50%);",
    },
    headerTitle:{
      fontFamily: "Inter",
      fontSize: 20,
      fontWeight: "600",
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
    },
    questionLink:{
      marginTop: 0,
      flexDirection: "row",
      justifyContent: "space-between",
      paddingVertical: 5,
    },
    questionLinkText: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "500",
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
      paddingVertical: 3,
    },
    answerText:{
      fontSize: 14,
      color: "#686873",
      paddingVertical: 5,
    },
    separator:{
      width: "100%",
      height: 0.5,
      backgroundColor: "#a0a0a0",
    },
    leftImg:{
      width: "30%",
      height: "100%",
      resizeMode: "cover",
    },
    gradBoxOneWrapper:{
      flex: 1,
      borderRadius: 15,
      paddingHorizontal: 40,
      paddingVertical: 20,
    },
    alertLink:{
      height: 40,
      width: 40,
      borderRadius: 20,
      backgroundColor: "white",
      alignItems: "center",
      justifyContent: "center",
    },
    iconForward:{ width: 24, height: 25, padding: 10 },
    contentWidget: {
      maxWidth: 1200,
      width: "100%",
      flexDirection: "row",
    },
    container: {
      paddingLeft: 20,
      width: "90%",
    },

    paymentMethodInfoBar: {
      flexDirection: "row",
      flexWrap: "wrap",
      borderRadius: 15,
      marginTop: 20.5,
      width: "100%",
      minHeight: 75.5,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
      marginLeft: 20,
      alignItems: "center",
      justifyContent: "center",
    },
    rechargeBody: {
      width: "100%",
      height: 510,
      backgroundColor: "#fff",
      borderRadius: 15,
      marginTop: 25,
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
      padding: 20,
      justifyContent: "space-between",
      flexDirection: "row",
      paddingTop: 20,
    },
    overlayContentStyle: {
      width: "60%",
      height: "90%",
      backgroundColor: "white",
      borderRadius: 15,
    },
    r0: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: 20,
      paddingRight: 35,
    },

    rechargeBodyTitle: {
      flexDirection: "row",
      alignItems: "center",
    },
    pdfViewStyle: {
      height: "90%",
      width: "100%",
    },
    backbutton: {
      width: 19,
      height: 19,
      marginRight: 20,
      paddingTop: 5.4,
      paddingRight: 7.7,
      paddingBottom: 5.8,
      paddingLeft: 6.7,
    },

    rechargeBodyHeading: {
      fontFamily: "Inter",
      fontSize: 13,
      color: "#999",
    },

    manageAutoButton: {
      width: 150,
      height: 30,
      borderRadius: 22,
      border: "solid 2px #bd2d37",
      alignItems: "center",
      justifyContent: "center",
    },

    mabLabel: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "bold",
      color: "#bd2d37",
    },

    r1: {
      flexDirection: "row",
      position: "relative",
      zIndex: 1,
    },

    rbr1c1: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 10,
    },
    viewStyle: { flexDirection: "row" },
    rbLabel: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#757575",
      textAlign: "right",
      position: "relative",
      zIndex: 1,
      marginLeft: 20,
    },

    dropDownViewStyle: {
      width: 230,
      height: 40,
      position: "relative",
      zIndex: 9999,
      opacity: 1,
      backgroundColor: "#fff",
      marginTop: 15,
    },

    dropdownHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      position: "relative",
      zIndex: 999,
      border: "2px solid #dfdfdf",
      padding: 10,
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      borderBottomWidth: 0,
    },

    secondViewStyle: {
      width: "40%",
    },
    firstViewStyle: {
      width: "60%",
      alignItems: "flex-start",
    },

    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },

    gradBoxOne: {
      borderRadius: 15,
      overflow: "hidden",
      minHeight: 170,
      maxHeight: 180,
      width: "100%",
      marginVertical: 15,
      backgroundColor: "#e9e9e9",
    },
    gradTitle: {
      color: "#25243b",
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "700",
    },
    gradSubTitle: {
      color: "#25243b",
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "500",
      marginVertical: 12,
      lineHeight: 20,
    },
    btnWidget: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginVertical: 6,
      alignSelf: "flex-end",
    },
    customerCareDetails: {
      flex: 1,
      borderRadius: 15,
      paddingRight: 20,
      paddingLeft: 40,
    },
  },

  {
    [maxSize(DEVICE_SIZES.SM)]: {
      rechargeBody: {
        height: 789,
        flexDirection: "column",
        marginTop: 0,
      },
      firstViewStyle: {
        width: "100%",
      },
      secondViewStyle: {
        width: "100%",
      },
      overlayContentStyle: {
        width: "90%",
      },
      customerCareDetails: {
        paddingLeft: 0,
      },
      overlayViewStyle: {
        marginLeft: -15,
      },
    },

    [maxSize(DEVICE_SIZES.MD)]: {
      container: { width: "80%" },
      rechargeBody: {
        height: 830,
        flexDirection: "column",
        marginTop: 0,
        paddingTop: 5,
        width: "100%",
      },
      firstViewStyle: {
        width: "100%",
        height: "48%",
        flex: 1,
      },
      secondViewStyle: {
        width: "100%",
        height: "48%",
        paddingVertical: 10,
        flex: 1,
      },
      overlayContentStyle: {
        width: "90%",
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        paddingTop: 20,
      },
      container: {
        minWidth: "60vw",
        width: "100%",
      },
      rechargeBody: {
        minWidth: "40vw",
        maxWidth: "90vw",
        height: 909,
        flexDirection: "column",
        marginTop: 0,
        paddingTop: 5,
        width: Dimensions.get("window").width,
      },
      firstViewStyle: {
        width: "100%",
      },
      secondViewStyle: {
        width: "100%",
      },
      gradBoxOne: {
        height: 140,
        minHeight: 101,
      },
      overlayContentStyle: {
        width: "90%",
      },
      pdfViewStyle: {
        alignItems: null,
      },
      customerCareDetails: {
        paddingLeft: 0,
      },
      overlayViewStyle: {
        marginLeft: -15,
      },
      headerTitle:{
        paddingVertical: 10,
      },
    },
  }
);

//make this component available to the app
export default useStyles;
